import styles from './About.module.scss';

const About = ({ description, image, title }) => {
    return (
        <section className={styles.about}>
            <h2 className={styles.title}>{title}</h2>
            <div className={styles.content}>
                <div className={styles.text}
                    dangerouslySetInnerHTML={{ __html: description }}
                />
                <div className={styles.image}>
                    <img src={image} alt="Газопоршневой генератор" />
                </div>
            </div>
        </section>
    );
};

export default About